import api from './api';

const authService = {
  login: async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  },

  register: async (userData) => {
    const response = await api.post('/auth/register', userData);
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('token');
  },

  getProfile: async () => {
    const response = await api.get('/users/profile');
    return response.data;
  },

  updateProfile: async (data) => {
    const response = await api.put('/users/profile', data);
    return response.data;
  },

  // Canviar-se la contrasenya un mateix, sabent-la. Demana l'actual: un testimoni dura set dies
  // i pot quedar-se en un navegador d'aula.
  changePassword: async (currentPassword, password) => {
    const response = await api.put('/users/password', { currentPassword, password });
    return response.data;
  },

  // «No puc entrar»: deixa una petició a la cua de l'administració. La resposta és sempre la
  // mateixa existeixi el compte o no, o sigui que aquí no hi ha res a interpretar.
  forgot: async (email) => {
    const response = await api.post('/auth/forgot', { email });
    return response.data;
  },

  // Contrasenya nova amb el codi que ha donat l'administració.
  reset: async (email, code, password) => {
    const response = await api.post('/auth/reset', { email, code, password });
    return response.data;
  },

  refreshToken: async (token) => {
    const response = await api.post('/auth/refresh-token', { token });
    return response.data;
  },
};

export default authService;